import { h, F as Fragment } from './index-6e9159ae.js';
import { L as LocalizedString } from './jsx-utils-1f9075fc.js';

const WrapHighlight = (props, children) => {
  return (h("span", { class: "font-bold", part: `highlight${props.part ? ` ${props.part}` : ''}` }, children));
};
const QuerySummaryCommon = (props) => {
  if (props.querySummaryState.hasError) {
    return;
  }
  if (!props.querySummaryState.firstSearchExecuted) {
    return (h("div", { part: "placeholder", "aria-hidden": "true", class: "h-6 my-2 w-60 bg-neutral rounded animate-pulse" }));
  }
  const key = props.querySummaryState.hasQuery
    ? 'showing-results-of-with-query'
    : 'showing-results-of';
  const params = {
    first: props.querySummaryState.firstResult.toLocaleString(),
    last: props.querySummaryState.lastResult.toLocaleString(),
    total: props.querySummaryState.total.toLocaleString(),
    query: props.querySummaryState.query,
    count: props.querySummaryState.lastResult,
  };
  if (props.querySummaryState.hasResults) {
    if (props.querySummaryState.isLoading) {
      props.setAriaLive(props.bindings.i18n.t('loading-results'));
    }
    else {
      props.setAriaLive(props.bindings.i18n.t(key, params));
    }
  }
  const paramsWithHighlights = {
    first: h(WrapHighlight, null, params.first),
    last: h(WrapHighlight, null, params.last),
    total: h(WrapHighlight, null, params.total),
    query: h(WrapHighlight, { part: "query" }, params.query),
  };
  return (h("div", { class: "text-on-background", part: "container" }, props.querySummaryState.hasResults && (h(Fragment, null,
    h(LocalizedString, { key: key, bindings: props.bindings, params: paramsWithHighlights, count: params.count }),
    props.querySummaryState.hasDuration && (h("span", { class: "hidden", part: "duration" },
      "\u00A0",
      h(LocalizedString, { key: "in-seconds", bindings: props.bindings, params: {
          count: props.querySummaryState.durationInSeconds.toLocaleString(),
        } })))))));
};

export { QuerySummaryCommon as Q };

//# sourceMappingURL=query-summary-common-8409aa1b.js.map